module.exports = __webpack_public_path__ + "static/img/view-01-main@t.0d9e206.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/ket/view-01-main@t.jpg
// module id = 53oH
// module chunks = 0